import React from 'react';
import { OnEnterArgs, State } from '..';
import { IApi } from 'utils/API';
import { INotificationContext } from 'utils/NotificationManager';
import Translation from 'utils/Language/Translation';

type Validate<S, P, R> = (args: OnEnterArgs<S, P, R>) => Promise<boolean>;

interface EventProps {
  api: IApi;
  notifications: INotificationContext;
}

interface Config<S, P, A, R> {
  nextState: number;
  validate: Validate<S, P, R>;
  errorKey: string;
}

const StateValidate = function <S, P extends EventProps, A extends { hint: string }, R>({
  nextState,
  validate,
  errorKey,
}: Config<S, P, A, R>): State<S, P, A, R> {
  return {
    onEnter: async (args) => {
      if (!(await validate(args))) {
        if (errorKey) {
          args.props.notifications.add('danger', <Translation name={errorKey} />);
        }
        throw new Error('validation failed');
      }
      return {
        type: 'MOVE',
        nextState,
      };
    },

    nodeName: 'T.states.validate',
    outputs: [
      {
        name: 'onOkay',
        to: nextState,
      },
    ],
  };
};

export default StateValidate;
